import { defineStore } from 'pinia';
import { DebtorFieldService } from '@/services/DebtorFieldService';

/**
 * Configuración de campos del componente "Datos del deudor" por tenant (despacho).
 * Carga la configuración persistida en base de datos para determinar qué campos
 * mostrar en cada pestaña y con qué etiqueta.
 */
export const useDebtorFieldsStore = defineStore('debtorFields', {
    state: () => ({
        profile: null,
        tabs: {},
        fields: [],
        headers: [],
        keys: [],
        loaded: false,
    }),
    getters: {
        // Encabezados listos para tablas / exportaciones (etiquetas en orden).
        headerList: (state) => state.headers,
    },
    actions: {
        async cargar() {
            const resp = await DebtorFieldService.getFields();

            if (!resp.error) {
                this.profile = resp.response.profile;
                this.tabs = resp.response.tabs || {};
                this.fields = resp.response.fields || [];
                this.headers = resp.response.headers || [];
                this.keys = resp.response.keys || [];
                this.loaded = true;
            }

            return resp;
        },
        limpiar() {
            this.profile = null;
            this.tabs = {};
            this.fields = [];
            this.headers = [];
            this.keys = [];
            this.loaded = false;
        },
    },
});